// @flow
import React, { Component, Fragment } from 'react';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames/bind';
import { getQempoAddress } from '../../../utils/qempoAdresses';
import { Helmet } from 'react-helmet';
import environment from '../../../environment';
import PropTypes from 'prop-types';

import coverImg from '../../../assets/img/meta-cover-lightblue.png';
import style from './Contact.scss';
import buttonStyle from '../../../assets/styles/button.scss';
import icons from '../../../assets/styles/icons.scss';

import type { AddressIntl } from '../../../utils/qempoAdresses';
import type { LocaleState } from '../../locale/duck';

type Props = {
  +locale: LocaleState;
};

const messages = defineMessages({
  US: {
    title: {
      id: 'contact.title.US',
    },
    description: {
      id: 'contact.description.US',
    },
    titleOg: {
      id: 'contact.title.og.US',
    },
    descriptionOg: {
      id: 'contact.description.og.US',
    },
  },
  PE: {
    title: {
      id: 'contact.title.PE',
    },
    description: {
      id: 'contact.description.PE',
    },
    titleOg: {
      id: 'contact.title.og.PE',
    },
    descriptionOg: {
      id: 'contact.description.og.PE',
    },
  },
  CO: {
    title: {
      id: 'contact.title.CO',
    },
    description: {
      id: 'contact.description.CO',
    },
    titleOg: {
      id: 'contact.title.og.CO',
    },
    descriptionOg: {
      id: 'contact.description.og.CO',
    },
  },
  default: {
    title: {
      id: 'contact.title',
    },
    description: {
      id: 'contact.description',
    },
    titleOg: {
      id: 'contact.title.og',
    },
    descriptionOg: {
      id: 'contact.description.og',
    },
  },
});

export default class Contact extends Component<Props, void> {

  render() {
    const { locale } = this.props;
    const addressPE: AddressIntl = getQempoAddress('PE');
    const addressCO: AddressIntl = getQempoAddress('CO');
    const title = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).title);
    const description = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).description);
    const titleOg = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).titleOg);
    const descriptionOg = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).descriptionOg);
    const baseUrl = environment.baseUrl[locale.domainCountry || 'US'];
    return <Fragment>
      <Helmet meta={[
        { name: 'description', content: description },
        { property: 'og:image', content: `${baseUrl}${coverImg}` },
        { property: 'og:title', content: titleOg },
        { property: 'og:description', content: descriptionOg },
        { name: 'twitter:title', content: title },
        { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
        { name: 'twitter:twitter:description', content: description },
      ]}>
        <title>{title}</title>
      </Helmet>
      <section className={style.contactWrap}>
        <FormattedMessage id="contact.text.title">
          {txt => <h1>{txt}</h1>}
        </FormattedMessage>
        <FormattedMessage id="contact.text">
          {txt => <p>{txt}</p>}
        </FormattedMessage>
        <section className={style.actionsWrap}>

          {/*<FormattedMessage id="contact.callButton">*/}
          {/*  {txt => (<a href="https://app.toky.co/qempo"*/}
          {/*              target="_blank"*/}
          {/*              className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}>*/}
          {/*    <i className={icons.symbolPhone}/>*/}
          {/*    {txt}*/}
          {/*  </a>)*/}
          {/*  }*/}
          {/*</FormattedMessage>*/}
          
          {/*<FormattedMessage id="contact.or"/>*/}

          <FormattedMessage id="contact.emailButton">
            {txt => (<a className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}
                        href="mailto:hola@qempo.com?Subject=Hola%20Qempo,%20necesito%20ayuda.">
              <i className={icons.iconMailMedium}/>
              {txt}
            </a>)
            }
          </FormattedMessage>

        </section>
        <FormattedMessage id="contact.emailText">
          {txt => <p className={style.hiddenSmall}>{txt} <a
            href="mailto:hola@qempo.com?Subject=Hola%20Qempo,%20necesito%20ayuda.">hola@qempo.com</a></p>}
        </FormattedMessage>

        <section className={style.addressWrap}>
          <div className={style.box}>
            <h2>LIM</h2>
            <p>Lima, Perú</p>
            <p>
              {/*<FormattedMessage id={addressPE.phone.value}>{*/}
              {/*  text => <a href="tel:+5117009795">{text}</a>*/}
              {/*}</FormattedMessage><br/>*/}
              <FormattedMessage id={addressPE.address.value}>{
                text => <span>{text}</span>
              }</FormattedMessage>
            </p>
          </div>
          <div className={style.box}>
            <h2>MIA</h2>
            <p>Florida, Estados Unidos</p>
            <p>
              <a href="tel:+5117009795">+1-305-985-4333</a><br/>
              14945 SW 34th ST,<br/>
              Miami FL 33185
            </p>
          </div>
          <div className={style.box}>
            <h2>MED</h2>
            <p>Medellin, Colombia</p>
            <p>
              <FormattedMessage id={addressCO.phone.value}>{
                text => <a href="https://wa.me/573176813983&text=urlencodedtext"
                           target="_blank">{text}</a>
              }</FormattedMessage><br/>
              <FormattedMessage id={addressCO.address.value}>{
                text => <span>{text}</span>
              }</FormattedMessage>
            </p>
          </div>
        </section>
      </section>
    </Fragment>;
  }
}

Contact.propTypes = {
  locale: PropTypes.object,
};

Contact.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/contact/components/Contact.jsx